import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { PageLayout } from "@/components/PageLayout";
import { Reveal } from "@/components/Reveal";
import { usePageMeta } from "@/hooks/usePageMeta";
import { PROGRAMS, BUSINESS } from "@/lib/constants";

export default function ProgramsPage() {
  usePageMeta(
    "Financial Education Programs | J11 Consulting",
    "Explore J11 Consulting's education and mentorship programs: credit education, funding readiness mentorship, business credit education and financial literacy coaching."
  );

  return (
    <PageLayout
      eyebrow="Programs"
      title="Education Designed Around Your Goals."
      subtitle="Every J11 Consulting program is built around education and mentorship — helping you understand credit, strengthen your financial foundation and prepare for future opportunities."
      testId="programs-page"
    >
      <section className="bg-[#0E0E12] py-14 lg:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-6 lg:grid-cols-2">
            {PROGRAMS.map((program, i) => (
              <Reveal key={program.slug} delay={i * 0.08}>
                <div
                  id={program.slug}
                  data-testid={`programs-page-card-${program.slug}`}
                  className="flex h-full scroll-mt-28 flex-col rounded-2xl border border-white/10 bg-[#17171C] p-7 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#C9A227]/30 hover:shadow-xl hover:shadow-black/40 sm:p-9"
                >
                  <span className="font-heading text-sm font-bold text-[#D8B54A]">0{i + 1}</span>
                  <h2 className="mt-3 font-heading text-xl font-semibold tracking-tight text-[#F2EEE3] sm:text-2xl">
                    {program.title}
                  </h2>
                  <p className="mt-3 text-sm leading-relaxed text-[#B8B2A6] sm:text-base">
                    {program.description}
                  </p>
                  <ul className="mt-5 space-y-2.5">
                    {program.topics.map((topic) => (
                      <li key={topic} className="flex items-start gap-2.5 text-sm text-[#B8B2A6]">
                        <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#D8B54A]" strokeWidth={2.5} />
                        {topic}
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/contact"
                    data-testid={`programs-page-cta-${program.slug}`}
                    className="group mt-7 inline-flex items-center gap-2 text-sm font-semibold text-[#D8B54A] transition-colors duration-200 hover:text-[#E4C463]"
                  >
                    Start With a Free Consultation
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
                  </Link>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.15}>
            <p
              data-testid="programs-page-disclaimer"
              className="mt-10 rounded-xl border border-white/10 bg-[#141419] px-6 py-4 text-[13px] leading-relaxed text-[#B8B2A6]"
            >
              {BUSINESS.shortName} provides education and mentorship. Results vary by individual. We
              do not guarantee credit score changes, approvals, funding amounts, interest rates or any
              specific financial outcome.
            </p>
          </Reveal>
        </div>
      </section>
    </PageLayout>
  );
}
